export default __webpack_public_path__ + "static/media/img_complete.da82ed8f.png";